import type { FlattenInterpolation } from 'styled-components';

import { css, type ThemeProps } from '../styled';
import { colorTextDark } from '../values';

function textBase(color: string, bold: boolean): FlattenInterpolation<ThemeProps> {
  return css<ThemeProps>`
    font-family: ${({ theme }) => theme.typos.fontFamily};
    font-weight: ${({ theme }) => (bold ? theme.typos.fontWeightBold : theme.typos.fontWeightNormal)};
    color: ${({ theme }) => color || theme.colors.colorTextDark};
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
  `;
}

export function textNormal(color = colorTextDark): FlattenInterpolation<ThemeProps> {
  return css`
    ${textBase(color, false)};
    font-size: ${({ theme }) => theme.typos.fontSizeTextNormal};
    line-height: ${({ theme }) => theme.typos.lineHeightTextNormal};
  `;
}

export function textNormalBold(color = colorTextDark): FlattenInterpolation<ThemeProps> {
  return css`
    ${textBase(color, true)};
    font-size: ${({ theme }) => theme.typos.fontSizeTextNormal};
    line-height: ${({ theme }) => theme.typos.lineHeightTextNormal};
  `;
}
